import { render, staticRenderFns } from "./ModalListadoPermisos.vue?vue&type=template&id=983168de&scoped=true"
import script from "./ModalListadoPermisos.vue?vue&type=script&lang=js"
export * from "./ModalListadoPermisos.vue?vue&type=script&lang=js"
import style0 from "./ModalListadoPermisos.vue?vue&type=style&index=0&id=983168de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983168de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('983168de')) {
      api.createRecord('983168de', component.options)
    } else {
      api.reload('983168de', component.options)
    }
    module.hot.accept("./ModalListadoPermisos.vue?vue&type=template&id=983168de&scoped=true", function () {
      api.rerender('983168de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/permisos/ModalListadoPermisos.vue"
export default component.exports